module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_08.08eda96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_08.png
// module id = k0LZ
// module chunks = 10